/** */
export const typeToTitle = type => {
  return type
    .split('_')
    .map(i => i[0].toUpperCase() + i.slice(1).toLowerCase())
    .join(' ')
}
